import axios, { AxiosResponse } from 'axios'

import { ShowCropWrite, ShowId, ShowRead, ShowWrite } from '@generated/types'

const BASE_URL = '/api/show'

export default {
  async fetchOne(id: ShowId): Promise<AxiosResponse<ShowRead>> {
    return axios.get(`${BASE_URL}/${id}/`)
  },

  async fetchAll(): Promise<AxiosResponse<ShowRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },

  async create(data: ShowWrite): Promise<AxiosResponse<ShowRead>> {
    return axios.post(`${BASE_URL}/`, data)
  },

  async update(data: ShowWrite): Promise<AxiosResponse<ShowRead>> {
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Show ID is required for update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/`, data)
  },

  async updateImage(id: ShowId, data: FormData): Promise<AxiosResponse<ShowRead>> {
    return axios.put(`${BASE_URL}/${id}/set_image/`, data)
  },

  async updateImagePosition(
    id: ShowId,
    data: {
      /* Define position data type if known */
    },
  ): Promise<AxiosResponse<ShowRead>> {
    return axios.put(`${BASE_URL}/${id}/set_image_position/`, data)
  },

  async updateCrops(id: ShowId, data: ShowCropWrite): Promise<AxiosResponse<ShowRead>> {
    return axios.put(`${BASE_URL}/${id}/set_crops/`, data)
  },

  async delete(id: ShowId): Promise<AxiosResponse> {
    return axios.delete(`${BASE_URL}/${id}/`)
  },

  async duplicate(id: ShowId): Promise<AxiosResponse<ShowRead>> {
    return axios.post(`${BASE_URL}/${id}/duplicate/`)
  },
}
